export default class UtilHelper {
  static getReponseMessage(obj, def = 'Houve uma falha na requisição.') {
    const mensagem = obj?.response?.data?.mensagem || obj?.data?.mensagem || obj?.mensagem;
    const message = obj?.response?.data?.message || obj?.data?.message || obj?.message;
    return mensagem || message || def;
  }
}
